import {MODEL_DATA} from './mutation-types';

export default {
  [MODEL_DATA](state, data) {
    state.modelData = data;
  },
};
